export class ImpressoraConfig {
    public nomeGrupo: string = '';
    public impressora: string = '';
    public modoFicha: boolean = false;
    public usarModoTela: boolean = false;
    public imprimirDuasVias: boolean = false;
}

export class GrupoImpressaoResponse {
    public grupo: string = '';
    public modoFicha: boolean = false;
    public usarModoTela: boolean = false;
    public imprimeDuasVias: boolean = false;
    public codigoComputador: number = 0;
    public impressora: string = '';
    public codigo: number = 0;
    public dets: ImpressaoDet[] = [];
}

export class FamiliaImpressaoRequest {
    public codFamilia: number = 0;
    public codigoImpressaoGrupoCab: number = 0;
}

export class ImpressaoDet {
    public codigoCab: number = 0;
    public codFamilia: number = 0;
    public codigo: number = 0;
}

export class ImpressaoGrupoRequest {
    public grupo: string = '';
    public impressora: string = '';
    public modoFicha: boolean = false;
    public usarModoTela: boolean = false;
    public imprimeDuasVias: boolean = false;
    public codigo: number = 0;
    public nomeComputador: string = "";
}